import './ReviewSwiper.css';

import React from 'react';
import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import { Avatar } from 'primereact/avatar';
import Grid from '@mui/material/Grid';

import { useMediaQuery } from 'react-responsive';

const testimonials = [
  {
    text: "Amei a experiência e o fato de ser super acessível! A clínica é maravilhosa, com profissionais super atenciosos!",
    name: "Laís Atonizio",
    date: "há 1 mês",
    stars: 5,
    avatar: "/assets/images/avatar-lais.png"
  },
  {
    text: "Ideia sensacional!! Triagem GRATUITA, recebo um relatório de risco e vou no médico parceiro com o preço da consulta super acessível! E são profissionais de verdade, qualificados que atendem os pacientes 😍❤️",
    name: "Gabriela Conicio",
    date: "há 3 meses",
    stars: 5,
    avatar: "/assets/images/avatar-gabriela.png"
  }
];

const TestimonialCarousel = () => { 

    const carouselRef = React.useRef(null);

    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const itemTemplate = (item) => (
    <div className="testimonialCard">
      <p className="testimonialText">“{item.text}”</p>
      <Rating value={item.stars} readOnly stars={5} cancel={false} className="testimonialStars" />
      <div className="testimonialFooter">
        <div className="testimonialUser">
          <Avatar image={item.avatar} shape="circle" size="large" />
          <div className="testimonialUserInfo">
            <div className="testimonialUserName">{item.name}</div>
            <div className="testimonialDate">{item.date}</div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="wrapper_quemsomos__content_container_block testimonialsBlock">
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <div className="testimonialsTextBlock">
            <div className="testimonialsTitle">O que falam de nós</div>
            <div className="testimonialsSubtitle">
              Veja o que nossos clientes têm a dizer sobre suas experiências e como nossos serviços têm feito a diferença em suas jornadas de saúde e bem-estar.
            </div>
            {/*<div className="testimonialNavButtons">
            <Button
                icon="pi pi-chevron-left"
                className="p-button-rounded p-button-text purple-nav"
                onClick={() => carouselRef.current?.prev()}
              />
              <Button
                icon="pi pi-chevron-right"
                className="p-button-rounded p-button-text purple-nav"
                onClick={() => carouselRef.current?.next()}
              />
            </div>*/}
          </div>
        </Grid>
        <Grid item xs={12} md={9}>
          <Carousel
            value={testimonials}
            numVisible={isMobile ? 1 : 2}
            numScroll={1}
            itemTemplate={itemTemplate}
            circular
            autoplayInterval={7000}
            showIndicators={false}
            showNavigators={true}
            className="testimonialCarousel"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default TestimonialCarousel;
